import { fromJS } from 'immutable'
import * as actionTypes from './constants'
import { LOGOUT } from '../authentication/constants'

const initialState = fromJS({})

function reducer (state = initialState, action) {
  switch (action.type) {
    case actionTypes.CLEAR_REVISION_IMPORT:
      return state
        .delete('uploadingFile')
        .delete('uploadFileError')
        .delete('file')
        .delete('planId')
        .delete('comparingResolution')
        .delete('compareResolutionError')
        .delete('compareResolutionResult')
        .delete('importingRevision')
        .delete('importRevisionError')
        .delete('generateOverlayError')
        .delete('overlayRevision')
        .delete('overlayFile')
        .delete('overlayRevisionOriginal')
        .delete('overlayFileOriginal')
        .delete('overlayScale')
    case actionTypes.UPLOAD_FILE:
      return state
        .set('uploadingFile', true)
        .delete('uploadFileError')
        .delete('file')
        .set('planId', action.planId)
    case actionTypes.UPLOAD_FILE_DONE:
      return state.set('file', action.file)
    case actionTypes.UPLOAD_FILE_ERROR:
      return state
        .set('uploadingFile', false)
        .set('uploadFileError', action.error)

    case actionTypes.COMPARE_RESOLUTION:
      return state
        .set('comparingResolution', true)
        .set('uploadingFile', false)
        .delete('compareResolutionError')
        .delete('compareResolutionResult')
    case actionTypes.COMPARE_RESOLUTION_DONE:
      return state
        .set('compareResolutionResult', action.result)
        .set('comparingResolution', false)
    case actionTypes.COMPARE_RESOLUTION_ERROR:
      return state
        .set('comparingResolution', false)
        .set('compareResolutionError', action.error)

    case actionTypes.IMPORT_REVISION:
      return state.set('importingRevision', true).delete('importRevisionError')
    case actionTypes.IMPORT_REVISION_DONE:
      return state.set('importingRevision', false)
    case actionTypes.IMPORT_REVISION_ERROR:
      return state
        .set('importingRevision', false)
        .set('importRevisionError', action.error)

    case actionTypes.LOAD_PLAN:
      return state.delete('loadPlanError').delete('plan')
    case actionTypes.PLAN_LOADED:
      return state.delete('loadPlanError').set('plan', action.plan)
    case actionTypes.LOAD_PLAN_ERROR:
      return state.set('loadPlanError', action.error)
    case actionTypes.START_GENERATE_OVERLAY:
      return state
        .set('generatingOverlay', true)
        .delete('generateOverlayError')
        .delete('overlayScale')
    case actionTypes.GENERATE_OVERLAY_ERROR:
      return state
        .set('generateOverlayError', action.error)
        .set('generatingOverlay', false)
    case actionTypes.GENERATE_FIRST_OVERLAY_DONE:
      return state.set(
        `overlay${action.fileType === actionTypes.generateOverlayTypes.FILE ? 'File' : 'Revision'}${action.originalColors ? 'Original' : ''}`,
        action.overlay
      )
    case actionTypes.GENERATE_OVERLAY_DONE:
      return state
        .set('generatingOverlay', false)
        .set(
          `overlay${action.fileType === actionTypes.generateOverlayTypes.FILE ? 'File' : 'Revision'}${action.originalColors ? 'Original' : ''}`,
          action.overlay
        )
        .set('overlayScale', action.overlay.output.scale / 100)

    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default reducer
